module.exports = __webpack_public_path__ + "static/img/newlogo.a8615912.jpg";